import {Grid, InputLabel, Stack} from '@mui/material';
import {AppControlledRadio} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';

interface RenderRadioProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderRadio: React.FC<RenderRadioProps> = ({field, control, gridSize, baseFieldName}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <InputLabel>
                    {field.title}
                    {field.isRequired && <span style={{color: 'red'}}>*</span>}
                </InputLabel>
                <AppControlledRadio
                    control={control}
                    name={`${baseFieldName}.value`}
                    options={field.defaultValue?.options ?? []}
                />
            </Stack>
        </Grid>
    );
};

export default RenderRadio;
